import { Component, ViewEncapsulation } from '@angular/core';
import { UIBlockingService } from '../core/ui-blocking.service';
import { AuthService } from '../core/auth.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { provideZxvbnServiceForPSM } from 'angular-password-strength-meter/zxcvbn';
import { PasswordStrengthMeterComponent } from 'angular-password-strength-meter';
import { CommonModule } from '@angular/common';
import { SetPasswordRequest } from '../core/set-password-request';
@Component({
  selector: 'app-reset-password',
  standalone: true,
  templateUrl: './reset-password.component.html',
  imports: [
    PasswordStrengthMeterComponent
    , ReactiveFormsModule
    , CommonModule

  ],
  providers: [UIBlockingService],
  styleUrls: ["../../assets/css/login.css"],
  encapsulation: ViewEncapsulation.None
})
export class ResetPasswordComponent {
  constructor(private authService: AuthService
    , private blockUI: UIBlockingService
    , private router: Router
    , private route: ActivatedRoute
    , private notificationService: ToastNotificationService
    , private fb: FormBuilder) { }

  resetToken: string | null = '';
  strength: number = 0;
  showErrors: boolean = false;
  resetForm: FormGroup = new FormGroup({
    password1: new FormControl('password1', Validators.required),
    password2: new FormControl('password2', Validators.required)
  });


  get pass1() { return this.resetForm.get('password1')?.value };
  get pass2() { return this.resetForm.get('password2')?.value };

  passwordMismatch() { return this.pass1 !== this.pass2 };
  lowStrength() { return  this.strength < 3 };
  tooShort() { return this.pass1.length < 8 };

  ngOnInit() {
    this.resetToken = this.route.snapshot.paramMap.get("token");
    this.resetResetForm();
  }


  private resetResetForm(): void {
    this.resetForm.reset();
    this.resetForm.patchValue({
      password1: '',  
      password2: ''
    });
  }

  strengthChanged(evt: number | null) {
    this.strength = evt == null ? 0 : evt;
  }

  disabledResetBtn(): boolean {

    if (this.lowStrength()) {
      return true;
    }
    if (this.tooShort()) {
      return true;
    }
    if (this.passwordMismatch()) {
      return true;
    }
    else {
      return false;
    }
  }

  initiateReset() {
    if (this.resetForm.invalid) {
      return;
    }

    if (this.disabledResetBtn()) {
      this.showErrors = true;

      return;
    }

    var request = new SetPasswordRequest()
    request.Password = this.pass1;
    request.RepeatPassword = this.pass2;
    request.ResetToken = this.resetToken;

    this.blockUI.start();

    this.authService.setPassword(request).then(() => {
      this.notificationService.success("Password Reset Successful");
      this.blockUI.stop();
      setTimeout(() => {                           //<<<---using ()=> syntax
        return this.router.navigate(['/admin-portal/login']);
      }, 1000);

    }, err => {
        this.blockUI.stop();
        console.log(err);

      this.notificationService.error(err.error);

    });
  }


}
